
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listings/[catalogId]/[tokenId]",
      function () {
        return require("private-next-pages/listings/[catalogId]/[tokenId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listings/[catalogId]/[tokenId]"])
      });
    }
  